<template>
  <div id="ouroboros-app">
    <!-- Splash overlay：全畫面蓋在最上層，與路由無關 -->
    <Splash v-if="showSplash" @done="onSplashDone" />

    <!-- 所有頁面都套書本外框，封面/內頁由 BookLayout 內部的 isCover 控制 -->
    <BookLayout>
      <router-view />
    </BookLayout>
  </div>
</template>

<script>
import BookLayout from '@/components/BookLayout.vue'
import Splash from '@/views/Splash.vue'

// module-level flag：JS 重新載入（刷新/新開tab）就重置，SPA 內部導航不重置
let splashPlayedThisSession = false

export default {
  name: 'App',
  components: { BookLayout, Splash },

  data() {
    const isRoot = window.location.pathname === '/'
    return {
      showSplash: isRoot && !splashPlayedThisSession,
    }
  },

  methods: {
    onSplashDone() {
      splashPlayedThisSession = true
      this.$store.commit('SET_SPLASH_PLAYED')
      this.showSplash = false
    },
  },
}
</script>

<style lang="scss">
#ouroboros-app {
  width: 100%;
  height: 100dvh;
  overflow: hidden;
}
</style>
